import KeplerSdk from './../../keplerSdk.js'

const state = {
    paymentMethods: [],
    paymentMethodsLastFetch: null,
}

const mutations = {
    SET_PAYMENT_METHODS_LIST (state, message) {
        state.paymentMethods = message
    },
    SET_PAYMENT_METHODS_LAST_FETCH (state, message) {
        state.paymentMethodsLastFetch = message
    },
}

const actions = {
    sample_call_all: ({dispatch, commit}, payload) => {
        //dispatch('fetchSubscriptions')
    },
    fetchPaymentMethods: ({commit}, payload) => {
        if (state.paymentMethodsLastFetch == null) {
            KeplerSdk.paymentMethodsList(function (data) {
                commit('SET_PAYMENT_METHODS_LAST_FETCH', Math.floor(Date.now() / 1000))
                commit('SET_PAYMENT_METHODS_LIST', data)
            }, function (error) {

            })
        }
    },
}

export default {
    state, mutations, actions
}


// WEBPACK FOOTER //
// ./src/store/frontoffice/paymentMethodsStore.js